import Axios from '@/assets/js/AxiosPlugin'
// 会员列表
export const searchMemberList = params => {
  return Axios.post('/api/Admin/Member/searchMemberList', params)
}
// 会员统计
export const memberStatistics = params => {
  return Axios.post('/api/Admin/Statistics/member', params)
}
// 查看充值消费明细
export const getRecords = params => {
  return Axios.post('/api/Admin/Member/getRecords', params)
}
// 查看充值消费明细
export const bindBalance = params => {
  return Axios.post('/api/Admin/Member/bindBalance', params)
}



// WEBPACK FOOTER //
// ./src/views/webpc/MemberManagement/MemberList/apis/index.js